import React from 'react'
import ConfigService from '../../services/configuracion/ConfigService';

const ButtonLink = ({ children, onClick, className, style, url, param, isAcceso = false, idAcceso = 0 }) => {

    const handleClick = () => {
        onClick(url, param);
    }

    let paths = ConfigService.getPaths();

    let findPath = paths?.find(value => value.url === url);

    if ((!findPath || findPath?.length === 0) && !isAcceso) return null;

    let acceso = ConfigService.findAccesoById(idAcceso);
    
    if (isAcceso && acceso === null) return null;

    return (
        <button
            className={className}
            style={style}
            onClick={() => handleClick()}>
            {children}
        </button>
    )

}

export default ButtonLink;